import { McpId } from './api';

/** Frontend MCP registry — display copy + endpoints + connect snippets. Endpoints verified live 2026-06-05. */
export interface McpRegistryEntry {
  id: McpId;
  name: string;
  endpoint: string;
  blurb: string;
  credentialKind: 'atlassian-jira' | 'atlassian-confluence-di' | 'n8n' | 'none';
  credentialHint: string;
}

export const MCP_REGISTRY: McpRegistryEntry[] = [
  {
    id: 'atlas-admin',
    name: 'Atlassian Admin',
    endpoint: 'https://d1ki5w6pod2yva.cloudfront.net/atlassian-admin/mcp',
    blurb: 'Jira, Confluence and JSM administration tools.',
    credentialKind: 'atlassian-jira',
    credentialHint: 'Needs a Jira-capable Atlassian credential',
  },
  {
    id: 'di-assets',
    name: 'DI Asset Management',
    endpoint: 'https://d2a5x4gvxr4zkj.cloudfront.net/di-assets/mcp',
    blurb: 'Skills, Claude Projects and artifact versioning.',
    credentialKind: 'none',
    credentialHint: 'No per-user credential — access via workspace membership',
  },
  {
    id: 'n8n',
    name: 'n8n Workflow Builder',
    endpoint: 'https://n8nmcp.diya.au/mcp',
    blurb: 'Build, validate and deploy n8n workflows.',
    credentialKind: 'n8n',
    credentialHint: 'Needs your n8n URL + API key',
  },
  {
    id: 'arl',
    name: 'ARL Doctrine',
    endpoint: 'https://arlmcp.diya.au/mcp',
    blurb: 'Read-only ARL Confluence doctrine (goals, ADRs, Cascade Standard).',
    credentialKind: 'atlassian-confluence-di',
    credentialHint: 'Needs a Confluence-capable designindustries.atlassian.net credential',
  },
  {
    id: 'jev',
    name: 'Jev (TypeSafe)',
    endpoint: 'https://jevmcp.diya.au/mcp',
    blurb: 'Ask TypeSafe\'s Jev decision model, behind DI guardrails and rate limits.',
    credentialKind: 'none',
    credentialHint: 'No per-user credential — uses the shared DI Jev key',
  },
];

/** Canonical Claude Code connect form (spec-gate decision: one form only). */
export function claudeCodeSnippet(entry: McpRegistryEntry): string {
  return `claude mcp add --transport http ${entry.id} ${entry.endpoint}`;
}

export function claudeAiSteps(entry: McpRegistryEntry): string[] {
  return [
    'Open claude.ai → Settings → Connectors',
    'Click "Add custom connector"',
    `Paste the endpoint URL: ${entry.endpoint}`,
    'Click Add, then Connect',
    'Sign in with your DI portal account when prompted (Cognito)',
    'When a tool first runs, choose "Allow always" so its tools are not blocked as "requires approval"',
  ];
}
